import { makeStyles } from '@material-ui/core/styles';
import { colors } from 'theme/color-palette';
const { FONT_COLOR, GREY, PURPLE, ERROR_FONT_COLOR } = colors;
import { Bogle_Regular } from 'constants/constant';
import { themedCheckbox } from 'theme/theme';

const filterExpandedStyle = makeStyles(() => ({
	relative: {
		position: 'fixed',
		width: '-webkit-fill-available'
	},
	titleContainer: {
		// position: 'fixed',
		width: '-webkit-fill-available'
	},
	titleFont: {
		fontSize: '20px',
		fontFamily: Bogle_Regular,
		fontWeight: 300,
		height: '50px',
		display: 'flex',
		alignItems: 'center',
		marginLeft: '16px',
		color: FONT_COLOR
	},
	subtitleFont: {
		height: '50px',
		display: 'flex',
		alignItems: 'center',
		color: FONT_COLOR
	},
	titleIcon: {
		marginRight: '8px'
	},
	backIcon: {
		position: 'fixed',
		marginLeft: '0px',
		justifyContent: 'start',
		color: GREY
	},
	searchBox: {
		position: 'fixed',
		marginTop: '51px',
		width: '-webkit-fill-available',
		height: '56px',
		'& .MuiInput-underline': {
			fontFamily: Bogle_Regular,
			height: '50px',
			borderBottom: 'none !important',
			'&:after': { borderBottom: 'none !important' },
			'&:before': { borderBottom: 'none !important' },
			'& .MuiInputAdornment-root': {
				marginLeft: '24px'
			}
		}
	},
	errorMsgBox: {
		position: 'fixed',
		marginTop: '100px',
		marginLeft: '18px',
		fontSize: '12px',
		color: ERROR_FONT_COLOR,
		display: 'flex',
		alignItems: 'center',
		'& .MuiSvgIcon-root': {
			fontSize: '12px'
		}
	},
	filterValueOptionBox: {
		padding: '0 16px',
		position: 'relative',
		top: '160px'
	},
	filterValuesBox: {
		padding: '0 16px',
		position: 'relative',
		top: '160px',
		height: '64vh',
		overflow: 'auto'
	},
	checkbox: themedCheckbox,
	checkboxIcon: {
		color: PURPLE
	},
	checkBoxLabel: {
		color: PURPLE,
		fontSize: '14px !important',
		display: 'flex'
	},
	valueCheckBoxLabel: {
		color: FONT_COLOR,
		fontSize: '14px !important',
		display: 'flex'
	},
	infoIcon: {
		position: 'fixed',
		right: '20px',
		marginTop: '16px',
		fontSize: '16px',
		color: GREY
	},
	deleteBtn: {
		'&.MuiButton-root': {
			color: `${PURPLE}`,
			fontFamily: Bogle_Regular
		},
		'&:hover': {
			backgroundColor: 'unset !important'
		}
	},
	customWidth: {
		maxWidth: '164px',
		fontFamily: Bogle_Regular
	},
	noMatchFoundBox: {
		position: 'fixed',
		width: '-webkit-fill-available',
		marginTop: '20%',
		textAlign: 'center'
	},
	noMatchFoundText: {
		color: GREY,
		fontSize: '14px !important',
		fontFamily: Bogle_Regular
	},
	addBtn: {
		color: `${PURPLE} !important`,
		fontFamily: Bogle_Regular,
		fontWeight: 'bold !important',
		'&:hover': {
			backgroundColor: 'unset !important',
			textDecoration: 'underline'
		}
	},
	contentContainer: {
		marginLeft: '20px',
		color: FONT_COLOR,
		fontSize: '16px',
		maxWidth: '320px'
	},
	allLinkRadio: {
		'&.MuiIconButton-root': {
			margin: '10px'
		}
	},
	descriptionLable: {
		color: GREY,
		fontSize: '12px',
		marginLeft: '28px',
		whiteSpace: 'pre-wrap'
	}
}));

export default filterExpandedStyle;
